module.exports = __webpack_public_path__ + "img/6.ab4bbfe5.png";